import React, { useState } from "react";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";

const CustomDropdown = ({ options, selected, onOptionSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const Parent = {
    width: "150px",
    position: "relative",
    color: "#374557",
    child: {
      borderRadius: "4px",
      padding: "10px",
      cursor: "pointer",
      selectedOption: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        img: {
          width: "20px",
        },
      },
    },
  };
  return (
    <div style={Parent}>
      <div
        className="d-flex align-items-center gap-3"
        onClick={toggleDropdown}
        style={Parent.child}
      >
        <div style={Parent.child.selectedOption}>
          {selected.flagIcon && (
            <img
              src={selected.flagIcon}
              style={Parent.child.selectedOption.img}
              alt={selected.label}
            />
          )}
          <span>{selected.label}</span>
        </div>
        {isOpen ? (
          <MdOutlineKeyboardArrowUp color="#A098AE" />
        ) : (
          <MdOutlineKeyboardArrowDown color="#A098AE" />
        )}
      </div>
      {isOpen && (
        <ul
          style={{
            listStyle: "none",
            padding: "0",
            margin: "5px 0 0 0",
            border: "1px solid #ccc",
            borderRadius: "4px",
            backgroundColor: "#fff",
            position: "absolute",
            width: "100%",
            zIndex: "1000",
          }}
        >
          {options.map((option) => (
            <li
              key={option.value}
              onClick={() => {
                onOptionSelect(option);
                setIsOpen(false);
              }}
              style={{
                padding: "10px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
                backgroundColor: "#fff",
                borderBottom: "1px solid #eee",
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff")}
            >
              {option.flagIcon && (
                <img src={option.flagIcon} width="20" alt={option.label} />
              )}
              <span>{option.label}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
